import i18n from '@/i18n';
import { Scatter } from './BaseChart';

export default {
  extends: Scatter,
  data() {
    return {
      datasets: [{
        label: this.$t('全體表現分佈').toString(),
        fill: false,
        borderColor: 'rgb(40, 168, 214)',
        backgroundColor: 'rgb(40, 168, 214)',
        data: [],
      }],
      options: {
        responsive: true,
        maintainAspectRatio: false,

        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: this.$t('分數').toString(),
            },

            ticks: {
              beginAtZero: true,
              callback(value) { // display only integer
                if (Number.isInteger(value)) { return value; }
                return null;
              },
              min: 0,
              max: 0,
            },
          }],
          xAxes: [{

            scaleLabel: {
              display: true,
              labelString: this.$t('答題秒數').toString(),
            },

            ticks: {
              beginAtZero: true,
              min: 0,
            },
          }],
        },
      },
    };
  },
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    highlight: { // {label: string, x: number, y: number}
      type: Object,
      default: null,
    },
    quizTotalScore: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    currentLang() {
      return this.$store.state.currentLang;
    },
  },
  async mounted() {
    this.setMaxNumber();
    this.fillChartData();
    this.fillHighlight();
    this.changeLang();

    this.renderChart({ datasets: this.$data.datasets }, this.options);
  },
  watch: {
    chartData() {
      this.fillChartData();
      this.renderChart({ datasets: this.$data.datasets }, this.options);
    },
    highlight() {
      this.fillHighlight();
      this.renderChart({ datasets: this.$data.datasets }, this.options);
    },
    currentLang() {
      this.changeLang();
    },
  },

  methods: {
    changeLang() {
      // console.log('currentLang:', this.currentLang);
      if (this.datasets.length === 1) { // 代表老師角度，看到所有學生的圖表
        this.datasets[0].label = this.$t('全體表現分佈').toString();
      }
      if (this.datasets.length > 1) { // 代表學生角度，僅看到單一學生的圖表
        this.datasets[1].label = this.$t('全體表現分佈').toString();
      }

      this.options.scales.yAxes[0].scaleLabel.labelString = this.$t('分數').toString();
      this.options.scales.xAxes[0].scaleLabel.labelString = this.$t('答題秒數').toString();
    },
    fillChartData() {
      if (this.chartData) {
        const lastIndex = this.datasets.length - 1;
        this.datasets[lastIndex].data = this.chartData;
      }
    },
    fillHighlight() {
      if (this.highlight) {
        const highlightData = {
          label: this.highlight.label,
          fill: false,
          borderColor: 'orange',
          backgroundColor: 'orange',
          data: [{
            x: this.highlight.x,
            y: this.highlight.y,
          }],
        };

        if (this.datasets.length < 2) {
          this.datasets.unshift(highlightData); // push front
        } else {
          this.datasets[0] = highlightData;
        }
      }
    },
    setMaxNumber() {
      console.log('本題總分', this.quizTotalScore);
      this.options.scales.yAxes[0].ticks.max = this.quizTotalScore;
    },
  },
};
